import Vue from 'vue'
import Router from 'vue-router'
import Signin from '@/components/Signin'
import Dashboard from '@/components/Dashboard'

Vue.use(Router)

export default new Router({
  routes: [
      {
      path: '/',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    }
  ]
})
